module.exports = __webpack_public_path__ + "static/media/black-quote.5e64c105.png";